/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Save_HInputs */

const en_wc_tut_save_h = /** @type {(inputs: Wc_Tut_Save_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Save, export and share`)
};

/**
* | output |
* | --- |
* | "7. Save, export and share" |
*
* @param {Wc_Tut_Save_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_save_h = /** @type {((inputs?: Wc_Tut_Save_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Save_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_save_h(inputs)
});
export { wc_tut_save_h as "wc.tut.save.h" }